import * as types from './action-types';
import { IEmailModelState } from "./state";

var initialState: IEmailModelState = {
    list: [],
    emailModelTemplateVariables: [],
    emailEngineVariableKeys :[]
}

export const Reducer = (state: IEmailModelState = initialState, action: any) => {
    let s = { ...state };

    switch (action.type) {
        case types.SET_EMAILMODELS:
            s.list = action.list;
            return s;

        case types.SET_EMAILMODELTEMPLATEVARIABLES:
            s.emailModelTemplateVariables = action.list;
            return s;

        case types.SET_EMAILENGINEVARIABLEKEYS:
            s.emailEngineVariableKeys = action.list;
            return s;
    }

    return state;
}